export const theme = {
    color: {
        black:           "rgba(0, 0, 0, 1)",
        white:           "rgba(255, 255, 255, 1)",
        gray:            "#ededed",
        borderGray:      "#dddddd",
        teal:            "#008181ff",
        tealHover:       "#006666",
        tealActive:      "#004c4c",
        green:           "hsl(122, 65%, 29%)",
        greenHover:      "hsl(122, 65%, 35%)",
        greenActive:     "hsl(122, 65%, 40%)",
        red:       "hsl(354, 84%, 54%)",
        redHover:  "hsl(354, 84%, 60%)",
        redActive: "hsl(354, 84%, 65%)",
    },
    breakpoints: {
        mobileMax: "767px",
    },
};